import {
  StoryEvCarRange,
  StoryJargonBuster,
} from '../../types/electric-cars-page'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import styles from './jargon-buster.module.css'
import sharedStyles from '../../landing-feature-electric-cars.module.css'
import { Wrapper } from '@cinch-nx/shared-ui'

interface JargonStoryBusterProps {
  jargonContent: StoryJargonBuster
}

interface JargonListProps {
  jargon: StoryEvCarRange
}

const JargonList = ({ jargon }: JargonListProps) => {
  const { title, text } = jargon
  const textContent = renderWithResolver(text)
  return (
    <li className={styles.jargonList}>
      <h3 className={styles.subheading}>{title}</h3>
      <div>{textContent}</div>
    </li>
  )
}

export const JargonBuster = ({ jargonContent }: JargonStoryBusterProps) => {
  const { title, body, jargonList } = jargonContent
  const bodyContent = renderWithResolver(body)
  return (
    <section className={styles.container}>
      <Wrapper isSlim>
        <h3 className={sharedStyles.heading}>{title}</h3>
        <div className={styles.subheading}>{bodyContent}</div>
        <ul>
          {jargonList.map((jargonItem) => (
            <JargonList
              key={`jargon-${jargonItem.title}`}
              jargon={jargonItem}
            />
          ))}
        </ul>
      </Wrapper>
    </section>
  )
}
